<template>
    <div id="app">
        <div v-bind:class="{ grayscale : isGrayscale }">
            <div id="mainmap">
                <b-button
                    icon-left="paint-roller"
                    :label="isGrayscale ? 'Couleur' : 'Niveau de gris'"
                    size="is-small"
                    type="is-info"
                    style="z-index: 1001; margin-left: 60px; margin-top: 10px"
                    @click="setGrayScale()">
                </b-button>

            </div>
        </div>
    </div>
</template>

<script>
    /*
     */
    import L from 'leaflet';
    import '../../node_modules/leaflet/dist/leaflet.css';
    import 'leaflet.vectorgrid';
    import 'leaflet-draw';
    import '../../node_modules/leaflet-draw/dist/leaflet.draw.css';
    import 'leaflet.pattern';
    import {GeoSearchControl, OpenStreetMapProvider} from 'leaflet-geosearch';
    import '../../node_modules/leaflet-geosearch/dist/geosearch.css';
    import {bus} from '@/main';
    import store from "@/components/store";
    // import * as turf from '@turf/turf'

    export default {
        name: "MapSites",
        mounted() {
            // Base map and background layers
            this.initMap();
            this.WMS();
        },
        created() {
            // Trigger reload layer
            bus.$on('refreshStoredMFUParcelles', () => {
                console.log('storedMFUParcelles function with : ', store.getters.colorsite, store.getters.territoire)
                this.storedMFUParcelles(store.getters.colorsite, store.getters.territoire)
            });
            bus.$on('newSpotSites', (x, y) => {
                // Remove old bounds
                this.focusgeom.clearLayers();
                // Add new bounds
                let spot = L.circleMarker([y, x], {
                    radius: 6,
                    color: '#f14668',
                    weight: 4,
                    fillOpacity: 0,
                    myCustomId: 'bounds',
                });
                // Add to map
                spot.addTo(this.focusgeom);
                this.map.setView([y, x], 15);
            });
            bus.$on('newBoundsSites', (e) => {
                // Remove old bounds
                this.focusgeom.clearLayers();
                // Add new bounds
                let bounds = L.geoJSON(JSON.parse(e), {
                    interactive: false,
                    color: '#f14668',
                    weight: 4,
                    fillOpacity: 0,
                    myCustomId: 'bounds',
                });
                // Add to map
                bounds.addTo(this.focusgeom);
                this.map.fitBounds(bounds.getBounds(), {
                    padding: [1, 1]
                });
            });
            // Reload if theme color pref is modified
            bus.$on('changeThemeColorSites', () => {
                this.storedMFUParcelles(store.getters.colorsite, store.getters.territoire)
            });
            bus.$on('addGeoserverlayerSites', (e) => {
                let l = this.geoserverLayers[e.name];
                if ( l !== undefined && this.geoserverLayerGroup.hasLayer(l)) {
                    this.geoserverLayerGroup.removeLayer(l);
                } else {
                    // Add the layer to the Geoserver group
                    const wms = L.tileLayer.wms(`https://opendata.cen-nouvelle-aquitaine.org/${e.repo}/wms?`, {
                        layers: e.name,
                        format: 'image/png',
                        transparent: true,
                        zIndex: 100,
                        minZoom: 8,
                        tiled: true,
                        opacity : e.sliderValue / 10
                    });
                    this.geoserverLayerGroup.addLayer(wms);
                    this.geoserverLayers[e.name] = wms;
                }
            });
            bus.$on('opacityGeoserverlayerSites', (e) => {
                let l = this.geoserverLayers[e.name];
                if ( l !== undefined && this.geoserverLayerGroup.hasLayer(l)) {
                    l.setOpacity(e.sliderValue / 10);
                } else {
                    console.log(`Layer ${e.name} not loaded`)
                }
            });

        },
        beforeDestroy() {
            bus.$off('refreshStoredMFUParcelles');
            bus.$off('newSpotSites');
            bus.$off('newBoundsSites');
            bus.$off('changeThemeColorSites');
            bus.$off('addGeoserverlayerSites');
            bus.$off('opacityGeoserverlayerSites');
        },
        methods: {
            setGrayScale() {
                this.isGrayscale = !this.isGrayscale
            },
            initMap() {
                // Map declaration
                this.map = L.map('mainmap').setView([45.05, 0.6167], 7);
                // Add a layers group to manage WMS layer from the geoserver
                this.geoserverLayerGroup.addTo(this.map)
                // Base layers
                let osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 100,
                    attribution: 'Fond cartographique : &copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a> | Données administratives : <a href="https://geoservices.ign.fr/adminexpress" target="_blank">ADMIN EXPRESS IGN</a> / <a href="https://cadastre.data.gouv.fr/datasets/cadastre-etalab" target="_blank">Cadastre Etalab</a>',
                    zIndex: 1,
                });
                // IGN BD ORTHO layer
                const m1 = L.tileLayer(
                    "https://data.geopf.fr/wmts?SERVICE=WMTS&VERSION=1.0.0" +
                    "&REQUEST=GetTile" +
                    "&STYLE=normal" +
                    "&TILEMATRIXSET=PM" +
                    "&FORMAT=image/jpeg"+
                    "&LAYER=ORTHOIMAGERY.ORTHOPHOTOS"+
                    "&TILEMATRIX={z}" +
                    "&TILEROW={y}" +
                    "&TILECOL={x}",
                    {
                        attribution: 'Fond cartographique : <a href="https://geoservices.ign.fr/documentation/donnees/ortho/bdortho" target="_blank">BD ORTHO&copy; IGN-F</a> | Données administratives : <a href="https://geoservices.ign.fr/adminexpress" target="_blank">ADMIN EXPRESS IGN</a> / <a href="https://cadastre.data.gouv.fr/datasets/cadastre-etalab" target="_blank">Cadastre Etalab</a>',
                        zIndex: 1,
                        maxZoom: 100,
                    });
                // IGN BD ORTHO IRC layer
                const m6 = L.tileLayer(
                    "https://data.geopf.fr/wmts?SERVICE=WMTS&VERSION=1.0.0" +
                    "&REQUEST=GetTile" +
                    "&STYLE=normal" +
                    "&TILEMATRIXSET=PM" +
                    "&FORMAT=image/jpeg"+
                    "&LAYER=ORTHOIMAGERY.ORTHOPHOTOS.IRC"+
                    "&TILEMATRIX={z}" +
                    "&TILEROW={y}" +
                    "&TILECOL={x}",
                    {
                        attribution: 'Fond cartographique : <a href="https://geoservices.ign.fr/documentation/donnees/ortho/bdortho" target="_blank">BD ORTHO&copy; IGN-F</a> | Données et intégration &copy; CEN Nouvelle-Aquitaine',
                        zIndex: 1,
                        maxZoom: 100,
                    });
                // OSM France layer
                const m3 = L.tileLayer("https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png",
                    {
                        maxZoom: 100,
                        attribution: 'Fond cartographique : &copy; <a href="https://openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a> / &copy; <a href="https://www.openstreetmap.fr/" target="_blank">Openstreetmap France</a>  | Données administratives : <a href="https://geoservices.ign.fr/adminexpress" target="_blank">ADMIN EXPRESS IGN</a> / <a href="https://cadastre.data.gouv.fr/datasets/cadastre-etalab" target="_blank">Cadastre Etalab</a>',
                        zIndex: 1,
                    });
                // OSM basque layer
                const osmBasque = L.tileLayer("https://tile.openstreetmap.bzh/eu/{z}/{x}/{y}.png",
                    {
                        maxZoom: 100,
                        attribution: 'Fond cartographique : &copy; <a href="https://openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a> / &copy; <a href="http://www.openstreetmap.bzh/" target="_blank">OpenStreetMap e brezhoneg</a>  | Données administratives : <a href="https://geoservices.ign.fr/adminexpress" target="_blank">ADMIN EXPRESS IGN</a> / <a href="https://cadastre.data.gouv.fr/datasets/cadastre-etalab" target="_blank">Cadastre Etalab</a>',
                        zIndex: 1,
                    });
                // OSM OpenTopo layer
                const m4 = L.tileLayer("https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
                    {
                        maxZoom: 100,
                        attribution: 'Fond cartographique : &copy; <a href="https://openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a> / &copy; <a href="https://viewfinderpanoramas.org/ target="_blank"">SRTM</a> / &copy; <a href="https://opentopomap.org/ target="_blank"">OpenTopoMap</a>  | Données administratives : <a href="https://geoservices.ign.fr/adminexpress" target="_blank">ADMIN EXPRESS IGN</a> / <a href="https://cadastre.data.gouv.fr/datasets/cadastre-etalab" target="_blank">Cadastre Etalab</a>',
                        zIndex: 1,
                    });
                //IGN SCAN25 temp gpf au 01/10/2024
                const scan25 = L.tileLayer.wms(
                    "https://data.geopf.fr/private/wms-r?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities&apikey=ign_scan_ws",
                    {
                        layers: 'SCAN25TOUR_PYR-JPEG_WLD_WM',
                        format: 'image/jpeg',
                        transparent: true,
                        attribution: 'Fond cartographique : <a href="https://geoservices.ign.fr/documentation/donnees/cartes/scan25" target="_blank">SCAN 25&copy; IGN-F</a> | Données administratives : <a href="https://geoservices.ign.fr/adminexpress" target="_blank">ADMIN EXPRESS IGN</a> / <a href="https://cadastre.data.gouv.fr/datasets/cadastre-etalab" target="_blank">Cadastre Etalab</a>',
                        //zIndex: 1,
                        //maxZoom: 100,
                    });
                    // Plan IGN IRC layer
                const planIGN = L.tileLayer(
                    "https://data.geopf.fr/wmts?SERVICE=WMTS&VERSION=1.0.0" +
                    "&REQUEST=GetTile" +
                    "&STYLE=normal" +
                    "&TILEMATRIXSET=PM" +
                    "&FORMAT=image/png"+
                    "&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2"+
                    "&TILEMATRIX={z}" +
                    "&TILEROW={y}" +
                    "&TILECOL={x}",
                    {
                        attribution: 'Fond cartographique : <a href="https://geoservices.ign.fr/documentation/donnees/cartes/planign" target="_blank">Plan IGN V2&copy; IGN-F</a> | Données et intégration &copy; CEN Nouvelle-Aquitaine',
                        zIndex: 1,
                        maxZoom: 100,
                        tileSize : 256
                    });

                // GeoSearch address
                const provider = new OpenStreetMapProvider();
                const searchControl = new GeoSearchControl({
                    provider: provider,
                });
                this.map.addControl(searchControl);
                // Initialise the FeatureGroup to store editable layers
                let editableLayers = new L.FeatureGroup();
                this.map.addLayer(editableLayers);
                let drawPluginOptions = {
                    position: 'topright',
                    draw: {
                        polygon: {
                            allowIntersection: false, // Restricts shapes to simple polygons
                            drawError: {
                                color: '#e1e100', // Color the shape will turn when intersects
                                message: '<strong>Ce n\'est pas possible de faire ça!</strong>' // Message that will show when intersect
                            },
                            shapeOptions: {
                                color: '#97009c'
                            }
                        },
                        // disable toolbar item by setting it to false
                        polyline: false,
                        circle: false, // Turns off this drawing tool
                        circlemarker: false, // Turns off this drawing tool
                        rectangle: false,
                        marker: false,
                    },
                    edit: {
                        featureGroup: editableLayers, //REQUIRED!!
                        remove: true
                    }
                };

                // Layer control on map
                this.stored = L.layerGroup();
                // Missing plot to add to sites
                this.missingPlots = L.layerGroup();

                // Add default basemap
                osm.addTo(this.map);

                // Add controls
                L.control.layers(
                    {
                        'OSM': osm,
                        "OSM France": m3,
                        "OSM Topo": m4,
                        "OSM Basque": osmBasque,
                        "Ortho IGN": m1,
                        "SCAN 25 IGN": scan25,
                        "Plan IGN": planIGN,
                        "Infra-rouge IGN": m6,
                    },
                    {
                        'Saisie': this.stored
                    }
                )
                    .addTo(this.map);


                // TODO draw stuff
                let drawControl = new L.Control.Draw(drawPluginOptions);
                this.map.addControl(drawControl);

                this.map.on('draw:created', function (e) {
                    let layer = e.layer;
                    editableLayers.addLayer(layer);
                });
            },
            WMS() {
                L.tileLayer.wms('https://opendata.cen-nouvelle-aquitaine.org/geoserver/administratif/wms?', {
                    layers: 'foncier_agg',
                    format: 'image/png',
                    transparent: true,
                    zIndex: 1000,
                    tiled: true,
                    tilesOrigin: -74.047185 + "," + 40.679648,
                    maxZoom: 100

                }).addTo(this.map);
            },
            storedMFUParcelles(color, idt) {
                this.$axios.get(`allMFU?idt=${idt}`)
                    .then(function (response) {
                        if (response.data.length) {
                            // Clear the existing Layers Group
                            this.stored.clearLayers();
                            // Draw each geom
                            response.data.forEach((element) => {
                                let geom = new L.geoJSON(JSON.parse(element.geom), {
                                    style: {
                                        weight: 2,
                                        opacity: 1,
                                        color: 'black',
                                        fillOpacity: 0.6,
                                        fillColor: color === "statut" ? element.color : this.createColor(element.nom_site)
                                    }
                                });

                                // Set idparcelle as layer id to retreive layer
                                geom.id = element.idparcelle;
                                // Popup on mouseover

                                    geom.bindPopup(
                                        `<b style="color: green; text-transform: uppercase;">${element.nom_site === null ? '' : element.nom_site}</b><br>` +
                                        `<b>Date début MFU:</b> ${element.date_debut_mfu}` +
                                        '<br><b>Code site: </b>' +
                                        element.codesite +
                                        '<br><b>Commune: </b>' +
                                        element.nom_commune +
                                        '<br><br><b>ID parcelle: </b>' +
                                        element.idparcelle +
                                        '<br><b>Section: </b>' +
                                        element.section +
                                        '<br><b>Numéro: </b>' +
                                        element.numero +
                                        '<br><b>Contenance: </b>' +
                                        this.contenanceToSurface(element.contenance) +
                                        '<br>⏮️ ' +
                                        element.last_libevenement +
                                        '</p></b>');

                                    // Action on each polygons
                                    geom.on('mouseover', (e) => {
                                        let popup = e.target.getPopup();
                                        popup.setLatLng(e.latlng).openOn(this.map);
                                    });
                                    geom.on('mouseout', (e) => {
                                        e.target.closePopup();
                                    });
                                    geom.on('mousemove', (e) => {
                                        e.target.closePopup();
                                        let popup = e.target.getPopup();
                                        popup.setLatLng(e.latlng).openOn(this.map);
                                    });
                                    // On right-click on the polygon
                                    geom.on('contextmenu', () => {
                                        if (element.idsite) {
                                            bus.$emit('getInfoSite', element.idsite)
                                        }

                                    });

                                // Event on click to modifiy if codesite is not NULL
                                if (element.codesite !== null) {
                                    geom.on('click', (e) => {
                                        bus.$emit('attachThisPlot', element.idparcelle)
                                        const currentColor = e.layer.options.color;
                                        if (currentColor === 'black') {
                                            // Change the color to a new color when clicked
                                            e.target.setStyle({ color: 'blue', weight: 5,});
                                        } else {
                                            // Revert the color to red when clicked again
                                            e.target.setStyle({ color: 'black', weight: 2});
                                        }
                                    });
                                }
                                // Add entity to the layers group
                                this.stored.addLayer(geom);

                                // If codesite is NULL, put a marker on top of the plot
                                if (element.codesite === null) {
                                    let circle = L.geoJSON(JSON.parse(element.geom_point), {
                                        pointToLayer: function (feature, latlng) {
                                            return L.circleMarker(latlng, {
                                                color: 'red',
                                                fillColor: 'red',
                                                fillOpacity: 0.8,
                                                radius: 10
                                            });
                                        }
                                    });
                                    // Event on click to add to a site if codesite is NULL
                                    circle.on('click', (e) => {
                                        // Attach an orphean plot to a site
                                        bus.$emit('attachThisPlot', element.idparcelle)
                                        const currentColor = e.layer.options.color;
                                        if (currentColor === 'red') {
                                            // Change the color to a new color when clicked
                                            e.target.setStyle({ color: 'blue', fillColor: 'blue' });
                                        } else {
                                            // Revert the color to red when clicked again
                                            e.target.setStyle({ color: 'red', fillColor: 'red' });
                                        }
                                    });
                                    this.stored.addLayer(circle.bringToFront());
                                }
                            });

                        } else { // No stored plots in the database
                            this.stored.clearLayers();
                        }
                    }.bind(this))
                    .catch(error => console.log(error));
                this.map.addLayer(this.stored)
                this.map.addLayer(this.missingPlots);
            },

            createColor(site) {
                if (site === null) {
                    return '#333333'
                }
                // Simple DJB2 hash function
                let hash = 5381;
                for (let i = 0; i < site.length; i++) {
                    hash = (hash * 33) ^ site.charCodeAt(i);
                }

                // Convert the hash to an RGB color
                const r = (hash & 0xFF);
                const g = ((hash >> 8) & 0xFF);
                const b = ((hash >> 16) & 0xFF);

                // Format the RGB values as an HTML color code
                return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
            },

            ToastRemove() {
                this.$buefy.toast.open({
                    duration: 300,
                    message: `Sélection supprimée`,
                    position: 'is-top',
                    type: 'is-danger'
                })
            },

            ToastAdd() {
                this.$buefy.toast.open({
                    duration: 300,
                    message: `Sélection ajoutée`,
                    position: 'is-top',
                    type: 'is-success'
                })
            },
        },
        data() { /* Data properties will go here */
            return {
                // Geoserver variables
                geoserverLayerGroup: L.layerGroup(),
                geoserverLayers: {},
                // Grayscale button
                isGrayscale: false,
                // Zoom min for parcelle
                zoomParcelle: 16,
                // Zoom max for aires
                zoomAire: 12,
                //
                focusgeom: null,
                // Dpt
                dpt: 24
            }
        }
    }
</script>

<style scoped>
    #mainmap {
        width: 100%;
        height: calc(100vh - 80px);
        z-index: 1;
    }
</style>

<style>
/* Trick to switch in B&W */
div.grayscale .leaflet-tile {
    filter: grayscale(100%);
}
</style>